import { SdkEventParameter, SdkInitParamenter } from "./interface";
import info from "./status";
import { muDuSdk } from "./muDuSdk";
import { PolyvSdk } from "./polyvSdk";
import { cr } from "fire-wind-water";

class Sdk {
  static modules: { [label: string]: string | any }[] = [];
  subscribeJSON: any = {};
  player: any = {};
  isPlaye: true;
  idx = 0;

  module(o) {
    const key = `sk_temp_webinar_sdk_${new Date().getTime()}`;
    Sdk.modules.push({
      key,
      model: o,
    });
    return {
      unsubscribe() {
        Sdk.modules = Sdk.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  //初始化
  init(data: SdkInitParamenter) {
    this.chooseThird(data);
    //监听 三方sdk发来的消息 往外发
    this.initSubscribe();
  }
  initSubscribe() {
    info.sdk.thirdSubscribe.subscribe((data: any) => {
      switch (data.type) {
        case "skPlayerStatus":
          this.skPlayerStatus(data.data);
          break;
        case "skPlayer":
          this.skPlayer(data.data);
          break;
        case "skStoped":
          this.skStoped(data.data);
          break;
        case "skEnded":
          this.skEnded(data.data);
          break;
        case "skSdkVideoChangeUrl":
          this.skSdkVideoChangeUrl(data.data);
          break;
        case "skPlayerInit":
          this.skPlayerInit(data.data);
          break;
        case "skPolyvNews":
          this.skPolyvNews(data.data);
          break;
      }
    });
  }

  //  根据参数选择是那个三方 和 直播还是点播
  chooseThird(data: SdkInitParamenter) {
    if (data.webCastProvider == "mudu") {
      this.player = new muDuSdk(data);
      this.skPlayEnd(1);
    } else if (data.webCastProvider == "polyv") {
      this.player = new PolyvSdk(data);
      this.skPlayEnd(1);
    } else {
      console.log(`%c 当前暂无该三方(${data.webCastProvider})SDK`, "color:red");
    }
  }

  skPlayerStatusChange(o) {
    console.log("推流中 和不退流 切换", o);
  }

  // 播放后的回掉
  skPlayEnd(o) {
    console.log("进入到 skPlayEnd", o);
  }

  skChangeUrlEmit(o) {
    console.log("切换视频", o);
  }

  skPlayerRemoveEmit(o) {
    console.log("sdk销毁", o);
  }

  isVideoPlayBackStatus() {
    cr.each(Sdk.modules, (d) => {
      if (d.model.isVideoPlayBackStatus) {
        d.model.isVideoPlayBackStatus();
      }
    });
  }

  onMuDuPlayerReady(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.onMuDuPlayerReady) {
        d.model.onMuDuPlayerReady(data);
      }
    });
  }

  switchVideo(data) {
    if (data.webCastProvider == "mudu") {
      this.player.changeVideoUrl(data);
    } else if (data.webCastProvider == "polyv") {
      this.player.changeVideoUrl(data);
    }
  }

  skPlayerRemove(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skPlayerRemove) {
        d.model.skPlayerRemove(data);
      }
    });
  }

  //外部监听的 函数
  skPptInfoChange(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skPptInfoChange) {
        d.model.skPptInfoChange(data);
      }
    });
  }

  skPlayerStatus(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skPlayerStatus) {
        d.model.skPlayerStatus(data);
      }
    });
  }
  skPlayer(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skPlayer) {
        d.model.skPlayer(data);
      }
    });
  }
  skStoped(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skStoped) {
        d.model.skStoped(data);
      }
    });
  }
  skEnded(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skEnded) {
        d.model.skEnded(data);
      }
    });
  }
  skSdkVideoChangeUrl(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skSdkVideoChangeUrl) {
        d.model.skSdkVideoChangeUrl(data);
      }
    });
  }
  skPlayerInit(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skPlayerInit) {
        d.model.skPlayerInit(data);
      }
    });
  }
  skPolyvNews(data) {
    cr.each(Sdk.modules, (d) => {
      if (d.model.skPolyvNews) {
        d.model.skPolyvNews(data);
      }
    });
  }
  remove() {
    this.player.player.remove();
  }
  skEvent(o: SdkEventParameter) {
    switch (o.type) {
      case "init":
        this.init(o.data);
        break;
      case "play":
        this.player.play(o.data);
        break;
      case "stop":
        this.player.stop(o.data);
        break;
      case "pause":
        this.player.pause(o.data);
        break;
      case "changeUrl":
        this.player.changeVideoUrl(o.data);
        break;
      case "remove":
        if (this.player && this.player != null) {
          this.player.remove();
        }
        break;
      case "switchVideo":
        this.switchVideo(o.data);
        break;
      case "polyvResizePpt":
        this.player.resizePpt();
        break;
      case "onPrev":
        this.player.onPrev();
        break;
      case "onNext":
        this.player.onNext();
        break;
      case "changeLineStream":
        this.player.changeLineStream();
        break;
    }
  }
}

export { Sdk };
